import styled from 'styled-components';
import { BaSeTheme } from '@base/react';

const {
  institucionais: { azulSebrae10 },
} = BaSeTheme.colors;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 1em;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconImage = styled.img`
  width: 30px;
  height: 30px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 0.5em;
`;

export const List = styled.ul<{ listType: 'dash' | 'bullet' }>`
  margin: 0;
  padding-left: ${({ listType }) => (listType === 'bullet' ? '20px' : '0')};
  list-style: ${({ listType }) => (listType === 'bullet' ? 'disc' : 'none')};
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ListItem = styled.li<{ listType: 'dash' | 'bullet' }>`
  color: ${azulSebrae10};

  display: flex;
  gap: 0.5em;
  ${({ listType }) =>
    listType === 'dash'
      ? `
  align-items: center;
    &::before {
      content: '- ';
    }
  `
      : `
  align-items: start;
    &::before {
      content: '• ';
      font-size: 1.2em;
    }
  `}
`;
